import React, { ComponentType } from "react";
import { SelectProps } from "@material-ui/core/Select";
import TrSelectData from "../../../models/shared/TrSelectData";
import {
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Chip,
  makeStyles,
  Theme,
  createStyles,
  Checkbox,
  ListItemText
} from "@material-ui/core";

interface Props extends SelectProps {
  label: string;
  selectData: TrSelectData<any>;
}

export default function TrSelect({
  required = false,
  selectData,
  label,
  name,
  value,
  className,
  id,
  disabled,
  multiple = false,
  error,
  fullWidth,
  onChange
}: Props) {
  const inputLabel = React.useRef<HTMLLabelElement>(null);
  const [labelWidth, setLabelWidth] = React.useState(0);
  React.useEffect(() => {
    setLabelWidth(inputLabel.current!.offsetWidth);
  }, []);

  const classes = useStyles();

  function getMenuItems(value: any) {
    let sd = JSON.parse(JSON.stringify(selectData)) as TrSelectData<any>;
    if (sd.emptyOption) {
      sd.data.unshift({});
    }

    return sd.data.map((data, i) => {
      return multiple ? (
        <MenuItem
          value={data[selectData.valueProp]}
          key={data[selectData.valueProp]}
        >
          <Checkbox
            checked={value && value.indexOf(data[selectData.valueProp]) > -1}
          />
          <ListItemText
            primary={
              selectData.textFunct
                ? selectData.textFunct(data)
                : data[selectData.textProp]
            }
          />
        </MenuItem>
      ) : i == 0 && selectData.emptyOption ? (
        <MenuItem value={undefined} key={0}>
          {" "}
        </MenuItem>
      ) : (
        <MenuItem
          value={data[selectData.valueProp]}
          key={data[selectData.valueProp]}
        >
          {selectData.textFunct
            ? selectData.textFunct(data)
            : data[selectData.textProp]}
        </MenuItem>
      );
    });
  }

  function getMenuItemText(value: any) {
    let data = selectData.data.find(sd => sd[selectData.valueProp] == value);

    if (data) {
      if (selectData.textFunct) {
        return selectData.textFunct(data);
      }

      return data[selectData.textProp];
    }

    return null;
  }

  return (
    <FormControl
      className={className}
      variant="outlined"
      required={required}
      error={error}
      fullWidth={fullWidth}
    >
      <InputLabel htmlFor={id} ref={inputLabel}>
        {label}
      </InputLabel>
      <Select
        multiple={multiple}
        value={value || ""}
        name={name}
        onChange={onChange}
        disabled={disabled}
        fullWidth={fullWidth}
        input={
          <OutlinedInput
            labelWidth={labelWidth}
            name={name}
            id={id}
            className={disabled ? "disabledInput" : ""}
          />
        }
        renderValue={
          multiple
            ? selected => (
                <div className={classes.chips}>
                  {(selected as any[]).map(value => (
                    <Chip
                      key={value}
                      label={getMenuItemText(value)}
                      className={classes.chip}
                    />
                  ))}
                </div>
              )
            : undefined
        }
      >
        {getMenuItems(value)}
      </Select>
    </FormControl>
  );
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    chips: {
      display: "flex",
      flexWrap: "wrap"
    },
    chip: {
      margin: 2
    }
  })
);
